export default __webpack_public_path__ + "static/media/main_inverse.85312ef0.png";